export default [
    {
        title : 'Dashboard',
        name : 'dashboard',
        icon: '',
    },
    {
        title : 'Nạp rút',
        name : 'wallet_request',
        icon: '',
    },
    // {
    //     title : 'Sự kiện',
    //     name : 'events',
    //     icon: '',
    // },
    {
        title : 'Truyện',
        name : 'story',
        icon: '',
    },
    {
        title : 'Truyện vi phạm',
        name : 'story_violate',
        icon: '',
    },
    {
        title : 'Báo cáo truyện',
        name : 'story_report',
        icon: '',
    },
    {
        title : 'Tác giả',
        name : 'author',
        icon: '',
    },
    {
        title : 'Email',
        icon: '',
        children: [
            {
                title : 'Gửi cho người dùng',
                name : 'user_email',
            },
            {
                title : 'Gửi cho tác giả',
                name : 'author_email',
            },
        ],
    },
    {
        title : 'Tài khoản',
        name : 'user',
        icon: '',
    },
    {
        title : 'Bình luận',
        name : 'comment',
        icon: '',
    },
    {
        title : 'Feedback',
        name : 'feedback',
        icon: '',
    },
    {
        title : 'Trả xu',
        name : 'author_pay_view',
        icon: '',
    },
    {
        title : 'Thông báo',
        name : 'notification',
        icon: '',
    },
    {
        title : 'Ví',
        name : 'wallet',
        icon: '',
    },
    {
        title : 'Cron Jobs',
        name : 'cron_jobs',
        icon: '',
    },
    // {
    //     title : 'Yêu cầu PR',
    //     name : 'qr_story_request',
    //     icon: '',
    // },
    {
        title : 'Affiliate',
        name : 'affiliate',
        icon: '',
    },
    {
        title : 'Cài đặt chung',
        name : 'setting',
        icon: '',
    }
]